export const prospectModelMixin = {
  data() {
    return {
      prospectModelObj: {
        org_id: null,
        trainer_id: null,
        firstName: '',
        lastName: '',
        alias: '',
        preferredName: '',
        connectionOptions: [
          {
            type: '',
            isPreferred: false,
            value: ''
          }
        ],
        emails: null,
        texts: null
      }
    };
  },
  methods: {
    getProspectModel() {
      return this.prospectModelObj;
    },
  },
};
